import React from 'react';

import { useQuery, useMutation } from '@tanstack/react-query';
import * as Yup from 'yup';

import CrudForm from '../../../components/Form/CrudForm';
import CrudPageLayout from '../../../layouts/CrudPageLayout';

import { US_STATES } from '../../../constants/formOptions';
import useUserData from '../../../hooks/useUserData';
import BrokerService from '../../../services/BrokerService';
import useUserRole from '../../../hooks/useUserRole';

const fields = [
  {
    label: 'Broker Name',
    type: 'text',
    name: 'name',
    placeholder: 'Type broker name',
    validation: Yup.string().required('This field is required'),
    fullWidth: true,
  },
  {
    label: 'Address Line 1',
    type: 'text',
    name: 'addressLine1',
    placeholder: 'Type address line 1',
    validation: Yup.string(),
    fullWidth: true,
  },
  {
    label: 'Address Line 2',
    type: 'text',
    name: 'addressLine2',
    placeholder: 'Type address line 2',
    validation: Yup.string(),
    fullWidth: true,
  },
  {
    label: 'City',
    type: 'text',
    name: 'city',
    placeholder: 'Type city',
    validation: Yup.string(),
  },
  {
    label: 'State',
    type: 'select',
    name: 'state',
    options: US_STATES,
    placeholder: 'Select state',
    validation: Yup.string(),
  },
  {
    label: 'Zip',
    type: 'text',
    name: 'zip',
    placeholder: 'Type zip',
    validation: Yup.number().typeError('Zip must be a number'),
  },
  {
    label: 'NMLS',
    type: 'text',
    name: 'nmls',
    placeholder: 'Type NMLS',
    validation: Yup.string(),
  },
];

export default function BrokerPage() {
  const { user } = useUserData();

  const { data: broker, refetch } = useQuery({
    queryKey: ['broker', user?.brokerId],
    queryFn: () => BrokerService.getBrokerById(user?.brokerId),
    enabled: !!user?.brokerId,
  });

  const { mutate: updateBroker } = useMutation({
    mutationFn: (formValues) =>
      BrokerService.updateBroker({ formValues, id: broker.id }),
    onSuccess: () => {
      refetch();
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const { isSuperAdmin } = useUserRole();

  return (
    <CrudPageLayout title="Broker">
      <CrudForm
        fields={fields}
        submitButtonLabel="Update"
        disabled={!isSuperAdmin}
        data={broker}
        updateHandler={updateBroker}
      />
    </CrudPageLayout>
  );
}
